import {
  ErrorWithData,
  ErrorWithMessage,
  ErrorWithMessageAndJson,
  ErrorWithResponse,
} from '../types/common';

export function assertErrorHasMessage(
  err: unknown
): asserts err is ErrorWithMessage {
  if (!(err as ErrorWithMessage).message) {
    // Should discuss, do we want to throw error here?
    // throw new Error('Error have no message body');
  }
}

export function assertErrorHasMessageAndJson(
  err: unknown
): asserts err is ErrorWithMessageAndJson {
  if (
    !(err as ErrorWithMessageAndJson).message ||
    !(err as ErrorWithMessageAndJson).jsonError
  ) {
    // Should discuss, do we want to throw error here?
    // throw new Error('Error have no message body');
  }
}

export function assertErrorHasData(err: unknown): asserts err is ErrorWithData {
  if (!(err as ErrorWithData).data) {
    // Should discuss, do we want to throw error here?
    // throw new Error('Error have no data body');
  }
}

export function assertErrorHasResponse(
  err: unknown
): asserts err is ErrorWithResponse {
  if (!(err as ErrorWithResponse).response) {
    // Should discuss, do we want to throw error here?
    // throw new Error('Error have no response body');
  }
}
